var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvisenseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "38px",
    height: "44px",
    viewBox: "0 0 38 44",
    enableBackground: "new 0 0 38 44",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 38,
    height: 44,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAsCAMAAAA+eDr6AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABOFBMVEUAAABprOVprOVprOVp rOVprOVprOVprOVprOVprOVprOVprOVprOVprOVprOViqORio9sxjd44kd84aqAwYJUxjd4wYJUx jd4wYJUxjd4wYJUxjd4wYJUxjd4xjd4wYJUxjd4wYJUwYJUwYJUxjd4wYJUwYJUxjd4wYJUwYJUx jd4wYJUwYJUxjd4xjd43gtI7fMo4dLtprOVlp+Axjd5NneJNhr0wYJU1j95mquVio9tGmeFCeK5b pONbmdE/leA7bqRUoOJQi8I0ZZpJgbhiqORDl+A+c6lXlMw4kd83ap9RnuI2hdQ1bKwyjN06fcs6 escxYpg3gtI7fMo3crY0idkyZZ85gM84db01h9czaaY6fs06ecM2brAyi9wxZJw4gdA4c7kzZ6I5 f845d8A1htU0a6n///8z+LUoAAAAMnRSTlMAcGAQ79+PgCC/r1BAnzCAgCDv7xCfn0Awz79gYBDv 34CA7yC/r0Dfz4+vUHBQMIC/cOuGKn8AAAABYktHRGdb0+mzAAAAB3RJTUUH5QoNETIJu8/FfwAA AYRJREFUOMuN0+dWAjEURlGqgGBHLIAFVOwlRGLvXaQYe+/v/whOuyE3M8xw/rrXknzJ+Hxq/oCv hYKhcLAF1kZIxFtFiVbUk8V01u6l4sQo4cHCJgu7qwix8ruPASzkNkoHEbU1Vwki1ek+BhRrpgIE Fff6/a6jdBGlbifV06uoYl/SgfXTVcxKLGVXA5SurctqgzE2aGNDlNJNmW1pbFhVaaq33VA7TC+D VXbEYLsNtmewUXyKMWq2D+qAmY2jMSwlTlE8tFguL7EJYDDKEYMm0RiiYxgDmhKsILETnZ1KbFr9 /RRGOWNyGTQGdE7IBWK5pHWZuMsSw80YbFZh5SuFpfBoZpVqrY7/ad7pCNec3yAGF4HOcMu17iTV uNa0xO519iCxOfzYzB650ZNQ8pMTt1V5NtmLOAV6wLBdmVu9ojHESzJP8QaK197lG1De5Ydg/NNg 88q3kC3AGNCXPobty1rQ2LfMftBbk17wL0f92b8/rcVKFbNaPe/AfEvLSivSH/8B7FzB9I1YPw8A AAAldEVYdGRhdGU6Y3JlYXRlADIwMjEtMTAtMTNUMTQ6NTA6MDkrMDM6MDB7cYtaAAAAJXRFWHRk YXRlOm1vZGlmeQAyMDIxLTEwLTEzVDE0OjUwOjA5KzAzOjAwCiwz5gAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisenseIcon);
export default __webpack_public_path__ + "static/media/InvisenseIcon.0a60f10a53cfeaf78c5730df3188ba1c.svg";
export { ForwardRef as ReactComponent };